export default "__VITE_ASSET__DCTCLKSS__"